export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9192.a8adb596.jpg";